// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Step } from '@med/app/home/demo/guided-tour/models/step';
import { SpinnerComponent } from '../../../../../shared/modules/spinner/components/spinner/spinner.component';

@Component({
  selector: 'e-guided-tour-skeleton',
  templateUrl: './guided-tour-skeleton.component.html',
  styleUrls: ['./guided-tour-skeleton.component.scss'],
  imports: [SpinnerComponent],
})
export class GuidedTourSkeletonComponent {
  @Input() step: Step;
  @Output() exitDemoClick = new EventEmitter<void>();
}
